<template>
  <div class="g-twbottom" :style="{ backgroundColor: newspaper_info.foot_img }">

    <img :src='"../../assets/tongwei/" + name + "_1.png"' alt="" class="u-twbottomBg" v-if="newspaper_info.n_type == 1">
    <img :src='newspaper_info.foot_img' alt="" class="u-twbottomBg" v-else>
    <input class="u-lookTwBefor" :id="'laydateInput' + index" @click="getDate()" v-show="!erShow" readonly
      v-if="newspaper_info.n_type == 1">
    <img src="../../assets/tongwei/bottomRight.png" alt class="u-bottomRght" @click="clickGeneratePicture(dom)"
      v-show="!erShow" v-if="newspaper_info.n_type == 1" />
    <router-link to="/search" tag="img" :src="require('../../assets/tongwei/search.png')" class="u-search" v-show="!erShow" v-if="newspaper_info.n_type == 1"></router-link>    
  </div>
</template>

<script>
import laydate from "layui-laydate";
import html2canvas from "html2canvas";
export default {
  name: "bottom",
  data() {
    return {
      imgUrl: "",
      imgShow: false,
      layerShow: false,
      erShow: false,
    };
  },
  props: {
    data: Object,
    dom: String,
    index: [String, Number],
    name: String,
    newspaper_info: Object
  },
  mounted() {
    // laydate.render({
    //     elem: ".u-lookBefor",
    //     type: "datetime",
    //     done: (value) => {
    //       console.log(value);
    //     },
    //   });
    this.getDate();
    this.$emit("isShowLaydate");
  },
  methods: {
    getDate: function () {

      let index = this.index;
      console.log(index)
      let that = this;
      let currentDate = '';
      this.$emit("isShowLaydate");
      if (this.getQueryString("date") == null) {
        currentDate = that.maxDate()
      } else {
        currentDate = this.getQueryString("date")
      }
      laydate.render({
        elem: "#laydateInput" + index,
        showBottom: false,
        max: that.maxDate(),
        value: currentDate,
        trigger: 'click',
        done: function (value, date, endDate) {
          console.log(value);
          console.log(date);
          console.log(endDate);
          window.location.href = "https://rm.tongwei.com/index/" + value
          that.$emit("isShowLaydate");
        },
      });

    },

    maxDate() {
      var now = new Date();
      return (
        now.getFullYear() + "-" + (now.getMonth() + 1) + "-" + now.getDate()
      );
    },

    clickGeneratePicture: function (dom) {
      this.erShow = true;
      this.layerShow = true;
      let that = this;
      console.log(document.getElementById(dom));
      this.$emit("func", { imgUrl: this.imgUrl, layerShow: this.layerShow });
      setTimeout(function () {
        html2canvas(document.getElementById(dom), {
          useCORS: true,
          logging: false,
        }).then((canvas) => {
          // 转成图片，生成图片地址

          this.imgUrl = canvas.toDataURL("image/png");
          var eleLink = document.createElement("a");
          eleLink.href = this.imgUrl; // 转换后的图片地址
          eleLink.download = "pictureName";
          // let img = new Image();
          // img.src = this.imgUrl;
          // img.onload = function () {
          //     that.imgShow = true;
          // };
          // // 触发点击
          // document.body.appendChild(eleLink);
          // eleLink.click();
          // // 然后移除
          // document.body.removeChild(eleLink);
          that.$emit("func", {
            imgUrl: this.imgUrl,
            layerShow: this.layerShow,
          });
          that.erShow = false;
        });
      }, 1000);
    },
    sendImg() {
      //func: 是父组件指定的传数据绑定的函数，this.msg:子组件给父组件传递的数据
    },
    closeLayer: function () {
      this.layerShow = false;
      this.imgShow = false;
    },

    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = decodeURI(window.location.search.substr(1)).match(reg);
      if (r != null) {
        return unescape(r[2]);
      }
      return null;
    },
  },
};
</script>

<style lang="scss" scoped>
.g-twbottom {
  // position: absolute;
  // bottom: 0;
  // left: 0;
  position: relative;
  flex-shrink: 0;
  -ms-flex-shrink: 0;
  display: flex;
  justify-items: center;
  justify-content: center;
  align-items: center;
  //   background: url('../../assets/tongwei/bottomBg.png');
  background-size: 100% 100%;
  height: 1.066667rem;

  margin: 0 -0.333333rem;
  margin-bottom: -.266667rem;

  img {
    max-width: 100%;
  }
}

.u-bottomLeft {
  width: 4.08rem;
  height: 0.613333rem;
  float: left;
}

.u-bottomRght {
  width: 1.653333rem;
  height: .64rem;
  position: relative;
  z-index: 999;
  margin-right: 0.266667rem;
}

.u-border {
  border-top: 0.133333rem solid #d1323b;
}

.u-page {
  float: right;
  color: #d1323b;
  font-size: 0.5rem;
  font-weight: bolder;
}

.u-er {
  width: 1.066667rem;
  height: 1.066667rem;
  float: right;
}

.u-lookTwBefor {
  width: 1.653333rem;
  height: .64rem;
  background-image: url(../../assets/tongwei/lookBefor.png);
  background-size: 100% 100%;
  border: none;
  color: transparent;
  background-color: transparent;
  margin-right: .266667rem;
  position: relative;
  z-index: 999;
}

::v-deep .layui-laydate {
  margin: 0;
  top: auto !important;
  bottom: 0;
}

.layui-laydate,
.layui-laydate-main,
.layui-laydate-content table {
  width: 100%;
}

.layui-laydate .layui-this {
  background: #274595 !important;
}

.u-twbottomBg {
  width: 100%;
  height: 1.066667rem;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 900;
}
</style>
<style>
.layui-laydate {
  margin: 0;
  top: auto !important;
  bottom: 0;
  left: 0 !important;
}

.u-search {
  width: .64rem;
  height: .64rem;
  position: relative;
  z-index: 999;
}
</style>